/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Manages slider states across ASAPConnect.
     */
    Alpine.store('slider', {
        /**
         * @var object Mapping of names to states for each registered slider.
         */
        status: {},

        /**
         * Display the specified slider.
         *
         * @return void
         */
        show(name) {
            setTimeout(() => {
                this.scrollToTop(name);
            }, 0);
            this.status[name] = true;
            Livewire.dispatch('sliderShown', {name: name});
        },

        /**
         * Hide the specified slider.
         *
         * @return void
         */
        hide(name) {
            this.status[name] = false;
            Livewire.dispatch('sliderHidden', {name: name});
        },

        /**
         * Toggle the specified slider.
         *
         * @return void
         */
        toggle(name) {
            if ((this.status[name] === undefined) || !this.status[name]) {
                this.show(name);
            } else {
                this.hide(name);
            }
        },

        /**
         * Check whether the specified slider should currently be displayed or not.
         *
         * @return bool
         */
        display(name) {
            var state = this.status[name];
            if (state === undefined) {
                state = false;
            }
            return state;
        },

        /**
         * Scroll slider to top.
         *
         * @param {String} name slider DOM identifier.
         */
        scrollToTop(name) {
            document.getElementById(name).scrollTop = 0;
        },
    });
});
